import React from 'react';
import './PagePolicy.scss';
import './PagePolicy-media.scss';
import { MediaContent } from '../../services/GlobalFunctions';
import Content from '../../components/Content/Content';

interface Props {
  title: string;
  content: string;
}

const PagePolicy = ({title, content}: Props) => {
  const body = (
    <div className="text-content page-policy">
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{__html: content}}/>
    </div>
  );
  return MediaContent(body, <Content block={body} />);
};

export default PagePolicy;
